import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import FaClose from 'react-icons/fa/times-circle'
import FaCaretRight from 'react-icons/fa/caret-right'
import FaQuestion from 'react-icons/fa/question-circle'
import { AzureMP } from 'react-azure-mp'

@autobind
class WorkStudentHelpModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      step: this.props.step
    }
  }

  closeModal () {
    this.props.onCloseModal()
  }

  toStep (s) {
    if (s > 4) {
      this.closeModal()
    } else {
      this.setState({step: s})
    }
  }

  render () {
    return (
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h4 className='modal-title'>Leaving great comments</h4>
            <span className='modal__close' onClick={this.closeModal}>
              <FaClose />
            </span>
          </div>
          <nav className='help__navigation'>
            <button className={!this.state.step ? 'active' : ''} onClick={() => this.toStep(0)}>Intro<span>duction</span></button>
            <button className={this.state.step === 1 ? 'active' : ''} onClick={() => this.toStep(1)}><span>Step </span>1</button>
            <button className={this.state.step === 2 ? 'active' : ''} onClick={() => this.toStep(2)}><span>Step </span> 2</button>
            <button className={this.state.step === 3 ? 'active' : ''} onClick={() => this.toStep(3)}><span>Step </span> 3</button>
            <button className={this.state.step === 4  ? 'active' : ''} onClick={() => this.toStep(4)}><span>Step </span> 4</button>
          </nav>
          <div className='modal-body help__content'>
            {this.state.step === 0 && <div className='help__video'>
              <AzureMP
                 skin="amp-flush"
                 src={[{src: "https://pobble-euwe.streaming.media.azure.net/85c45203-b07e-4bcc-8d64-a382ff284e99/270819_Pupil commenting intro.ism/manifest", type: "application/vnd.ms-sstr+xml" }]}
               />
            </div>}
            {this.state.step === 1 && <div>
              <h3 className='help__title'>First be positive and say something that you like about the piece of work.</h3>
              <ul className='help__list'>
                <li><FaQuestion/><span>I really like the ...</span></li>
                <li><FaQuestion/><span>You have used some great ...</span></li>
                <li><FaQuestion/><span>My favourite part is ...</span></li>
              </ul>
            </div>}

            {this.state.step === 2 && <div>
              <h3 className='help__title'>Next make a suggestion to help the young writer. </h3>
              <ul className='help__list'>
                <li><FaQuestion/><span>Have you thought about using ...</span></li>
                <li><FaQuestion/><span>Perhaps you could ...</span></li>
                <li><FaQuestion/><span>To make your writing even better, I would recommend ...</span></li>
              </ul>
            </div>}

            {this.state.step === 3 && <div>
              <h3 className='help__title'>Then offer some encouragement to make the author smile.</h3>
              <ul className='help__list'>
                <li><FaQuestion/><span>I can't wait to read your next piece of work</span></li>
                <li><FaQuestion/><span>Congratulations on becoming a published author</span></li>
                <li><FaQuestion/><span>Keep up the great writing</span></li>
              </ul>
            </div>}

            {this.state.step === 4 && <div>
              <h3 className='help__title'>Finally check your comment.</h3>
              <ul className='help__list'>
                <li><FaQuestion/><span>Is your comment kind, specific and helpful?</span></li>
                <li><FaQuestion/><span>Did you use correct spelling and punctuation?</span></li>
                <li><FaQuestion/><span>Many people will read your comment. Are you proud of it?</span></li>
              </ul>
            </div>}
          </div>
          <div className='modal-footer'>
            {this.state.step !== 4 && <span className='btn btn-link' onClick={this.closeModal}>Cancel</span>}
            <button className='btn btn-primary' onClick={() => this.toStep(this.state.step + 1)}>{this.state.step !== 4 ? 'Next step' : 'Close'}</button>
          </div>
        </div>
      </div>
    )
  }
}

export default WorkStudentHelpModal

WorkStudentHelpModal.propTypes = {
  step: PropTypes.number
}



// WEBPACK FOOTER //
// ./components/work/WorkStudentHelpModal.js